export class ConfigClass {
    locale = 'en-US';
    loginApiUrl = '';
    loginId = '';
    eventService = Object.create({});
    projectId = '';
    purchase = {
        purchaseWithRealCurrency: () => ({}),
        purchaseFreeItem: async () => await Promise.resolve({}),
        purchaseWithVirtualCurrency: async () => await Promise.resolve({}),
    };
    setConfig(data) {
        Object.assign(this, data);
        return this;
    }
}
